<!--<div class="flex p-2 gap-2 flex-wrap" *ngIf="tmplCategories$ | async as categoryList; else load">
   <ng-container *ngFor="let category of [categoryList] | applyMiddleware: 'categoryList' | async">
   <button tailBtn class="capitalize" [class.active]="category === (selectedCategory$ | async)"
            (click)="selectCategory(category)">
      {{category.category}}
    </button> 
  </ng-container>
</div>-->
<div class="category-list">
  <div
    class="{{
      categoryList?.length == 0 ? 'text-center' : 'row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3'
    }}"
    *ngIf="tmplCategories$ | async as categoryList; else load"
  >
    <ng-container *ngIf="categoryList?.length == 0">
      <p
        class="position-absolute top-50 start-50 translate-middle"
        style="z-index: 10"
      >
        No templates in this category
      </p>
    </ng-container>
    <div class="col"
      *ngFor="
        let category of [categoryList] | applyMiddleware : 'categoryList' | async;
        index as i
      "
    >
      <div
        class="border position-relative  d-flex justify-content-between rounded border-gray-200 bg-white text-sm uppercase text-center p-3 cursor-pointer select-none"
      >
        <div class="category-temp" (click)="onselectedTemplate(category, i)">
          <span >
            {{ category.category | truncate :  12}}
          </span>
          <p class="tooltip">{{ category.category}}</p>
        </div>
        <div class="tool-btn">
          <button
            class="tool-button text-red-700/75"
            (click)="openDeleteTemplateModal($event,i)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-3 w-3"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="categoryList?.length">
  <div class="pagination-control pagination-center mt-2">
     <ngb-pagination
       #ngbPage
       [boundaryLinks]="false"
       [collectionSize]="totalRecords"
       [pageSize]="pageSize"
       [page]="page"
       [maxSize]="15"
       (pageChange)="onPageChanged($event)"
     >
       <ng-template ngbPaginationPrevious>&#8810;</ng-template>
       <ng-template ngbPaginationNext>&#8811;</ng-template>
     </ngb-pagination>
   </div>
</ng-container>

<div class="grid grid-cols-3 gap-2 p-2" *ngIf="selectedCategory$ | async as category">
  <!--  <ng-container *ngIf="[category] | applyMiddleware: 'categoryTemplates' | async as templates; else emptyBodyMessage">-->
  <!-- <ng-container *ngFor="let template of [category]| applyMiddleware: 'categoryTemplates' | async">
        <div style="cursor: pointer;" class="border rounded border-gray-200 bg-white text-sm uppercase text-center p-4 cursor-move select-none" (click)="selectedTemplate(category)">
          {{ template }}
        </div>
      </ng-container> -->
  <!-- <ng-container *ngFor="let template of [category] | applyMiddleware: 'categoryTemplates' | async">
    <div class="relative h-60 rounded border overflow-hidden group">
      <img [src]="[category.category, template] | applyMiddleware: 'templateThumbnail'" [alt]="template"
           class="w-full h-full object-cover object-[center_top] group-hover:object-bottom">
      <div
        class="absolute bottom-0 w-full bg-white translate-y-5 p-2 group-hover:translate-y-0 transition-transform text-center">
        <h3 tailH3>{{template | titlecase}}</h3>
       <button tailBtn class="opacity-0 group-hover:opacity-100 transition-opacity mx-auto" i18n="@@use_in_editor"
                (click)="selectTemplate(category.category, template)">
          Use in editor
        </button> 
        <button tailBtn class="opacity-0 group-hover:opacity-100 transition-opacity mx-auto" i18n="@@use_in_editor"
                (click)="selectedTemplate(category)">
          Use in editor
        </button>
      </div>
      
    </div>
  </ng-container> -->

  <!--  </ng-container>-->
</div>

<ng-template #load>
  <p i18n="@@loading_templates">Loading, please wait ...</p>
</ng-template>

<ng-template #emptyBodyMessage>
  <p i18n="@@empty_template_list">No templates in this category</p>
</ng-template>
